import api, { manageError } from "config/api";

export const getOpenEvents = async (type) => {
  let url;
  if (type) {
    url = `/events/open?type=${type}`;
  } else {
    url = "/events/open";
  }
  const response = await api.get(url);

  return response.data;
};

export const saveReservation = async (eventId, assistants, ticket) => {
  let url;
  if (ticket) {
    url = `/events/reservation/${eventId}?ticket=${ticket}`;
  } else {
    url = `/events/reservation/${eventId}`;
  }
  const response = await api.post(url, {
    assistants,
  });
  return manageError(response);
};

export const getReservationInfo = async (code) => {
  const response = await api.get(`/events/reservation/${code}`);
  return manageError(response);
};

export const getReservationByPerson = async (values) => {
  const response = await api.post(`/events/person/reservation`, values);
  return manageError(response);
};

export const cancelReservation = async (reservation) => {
  const response = await api.post(`/events/cancel/reservation`, reservation);
  return manageError(response);
};

export const getAllEvents = async () => {
  const response = await api.get(`/events`);
  return manageError(response);
};

export const getEventsByState = async (state) => {
  const response = await api.get(`/events/state/${state}`);
  return manageError(response);
};

export const checkReservation = async (reservation) => {
  const response = await api.post(`/events/reservation/completed`, reservation);
  return manageError(response);
};

export const getAssistantsByEventId = async (eventId) => {
  const response = await api.get(`/events/assistant/${eventId}`);
  return manageError(response);
};

export const getAllBookingsByEvent = async (id) => {
  const response = await api.get(`/events/all/${id}`);
  return manageError(response);
};

export const getAllEventsByDate = async (date) => {
  const response = await api.get(`/events/date/${date}`);
  return manageError(response);
};

export const getReservationsByDate = async (date) => {
  const response = await api.get(`/events/booking/date/${date}`);
  return manageError(response);
};

export const createEvent = async (values) => {
  const response = await api.post("/events", values);
  return manageError(response);
};

export const updateEvent = async (id, values) => {
  const response = await api.put(`/events/${id}`, values);
  return manageError(response);
};

export const closeEvent = async (id) => {
  const response = await api.put(`/events/close/${id}`);
  return manageError(response);
};

export const closeAllEvents = async () => {
  const response = await api.put(`/events/close`);
  return manageError(response);
};

export const getMockEvents = () => [
  {
    id: "Zkq2s4NlFsUl9p8c9Qz4",
    code: "400",
    capacity: 400,
    date: "2021-10-21",
    type: "ADN",
    availableCapacity: 259,
    state: "OPEN",
    description:
      'Entrenamiento Provida "El milagro de la vida" - 6 PM | 2021-10-21',
    completed: null,
    booking: null,
    week: null,
    capacity25: 12,
    capacity610: 21,
    capacity1114: 9,
    availableCapacity25: 12,
    availableCapacity610: 21,
    availableCapacity1114: 9,
  },
];

export const mockSaveReservation = (eventId, assistants) => {
  return { code: "7qyaBlZFyEMdDUrR0qfs" };
};
